module.exports = __webpack_public_path__ + "img/kg.91e3acf4.svg";